import React from 'react';
import { useTranslation } from "react-i18next";


const BanksReview = () => {
    const { t } = useTranslation();

    return (
        
        <div>
        <main className="overview">
          <div className="overview__container">
            {/* Отчеты по годам */}
            <section className="annual-reports">
              <h2 className="annual-reports__title">{t("overview.annualReports.title")}</h2>
              <div className="annual-reports__grid">
                {Object.keys(t("overview.annualReports.years", { returnObjects: true })).map((year) => (
                  <div className="annual-reports__card" key={year}>
                    <h3 className="annual-reports__year">{year}</h3>
                 
                    <section className="report">
                      <h2 className="report__title">{t("overview.annualReports.detailedReport")}</h2>
                      <a href="#" className="report__button">
                        <span className="report__icon">📊</span>
                        {t("overview.annualReports.downloadReport")}
                      </a>
                    </section>
                  </div>
                ))}
              </div>
            </section>
  
            {/* Анализ развития */}
            <section className="analysis">
              <h2 className="analysis__title">{t("overview.analysis.title")}</h2>
              <div className="analysis__content">
                {Object.keys(t("overview.analysis.sections", { returnObjects: true })).map((sectionKey) => (
                  <div className="analysis__section" key={sectionKey}>
                    <h3 className="analysis__section-title">{t(`overview.analysis.sections.${sectionKey}.title`)}</h3>
                    <p className="analysis__text">{t(`overview.analysis.sections.${sectionKey}.text`)}</p>
                  </div>
                ))}
              </div>
            </section>
  
            {/* Подробный отчет */}
            <section className="report">
              <h2 className="report__title">{t("overview.annualReports.detailedReport")}</h2>
              <a href="#" className="report__button">
                <span className="report__icon">📊</span>
                {t("overview.annualReports.downloadReport")}
              </a>
            </section>
          </div>
        </main>
      </div>
    );
}

export default BanksReview;
